// extracted by mini-css-extract-plugin
module.exports = {"tag":"Tag_tag__1ygke","rotate":"Tag_rotate__dVSB5","slideIn":"Tag_slideIn__S6M2K","fadeIn":"Tag_fadeIn__JGZXe"};